import { useEffect } from "react";

/**
 * Lightweight SEO hook — updates document.title, meta description,
 * canonical, and Open Graph / Twitter tags without a runtime dependency.
 */
const SITE_NAME = "ConnectHER";
const SITE_URL = "https://thechhq.com";
const DEFAULT_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_upgrade-web-4/artifacts/qbbdrrns_FFDD0762-32FF-400B-8794-0C2705294CCC.png";

function upsertMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function useSeo({
  title,
  description,
  path,
  image,
  type = "website",
} = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} · ${SITE_NAME}`
      : `${SITE_NAME} — The Divine Connector`;
    const desc =
      description ||
      "ConnectHer — The Divine Connector. Bookkeeping, business support, credit repair, taxes, travel, and more for entrepreneurs, nonprofits, and small businesses.";
    const url = path ? `${SITE_URL}${path}` : SITE_URL;
    const ogImage = image || DEFAULT_OG_IMAGE;

    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertLink("canonical", url);

    // Open Graph
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("property", "og:site_name", SITE_NAME);

    // Twitter
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", ogImage);
  }, [title, description, path, image, type]);
}
